const initHeaderPhone = () => {
  document.querySelectorAll('[data-header-phone]').forEach((root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.init === 'true') return;
    root.dataset.init = 'true';

    const button = root.querySelector('[data-phone-toggle]');
    const popover = root.querySelector('[data-phone-popover]');

    if (!(button instanceof HTMLElement)) return;
    if (!(popover instanceof HTMLElement)) return;

    const close = () => {
      popover.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      popover.hidden = false;
      button.setAttribute('aria-expanded', 'true');
    };

    const toggle = () => {
      if (popover.hidden) open();
      else close();
    };

    button.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });

    root.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.closest('[data-phone-toggle]')) return;
      const link = target.closest('a[href^="tel:"]');
      if (link) close();
    });

    document.addEventListener('pointerdown', (e) => {
      const target = e.target;
      if (!(target instanceof Node)) return;
      if (root.contains(target)) return;
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      close();
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderPhone, { once: true });
} else {
  initHeaderPhone();
}

